import { render, staticRenderFns } from "./randomBob.vue?vue&type=template&id=669290c8&scoped=true&"
import script from "./randomBob.vue?vue&type=script&lang=js&"
export * from "./randomBob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669290c8",
  null
  
)

/* custom blocks */
import block0 from "./randomBob.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports